export default __webpack_public_path__ + "static/token-intro-background-dbf665fae87ac36c767e9c89c4059daf.gif";